const fahField = document.querySelector("#fahrenheit")

document.querySelector("#celsius").addEventListener("input", aAction)

function aAction(e) {
  const celsiusValue = e.target.value
  
  if (isNaN(celsiusValue) || celsiusValue == "") {
    fahField.textContent = "Only numbers, please!"
    return
  }
  
  const newTemp = celsiusValue * 1.8 + 32
  
  fahField.textContent = newTemp
}

